// Copyright (c) 2017 Deere & Company

import React, {PropTypes} from 'react';
import EditableField from '../../../shared/components/editable-field';
import {FormattedMessage} from 'react-intl';
import FormattedNumberInput from '../../../shared/components/formatted-number-input';
import Rate from '@deere/cps-it.warranty-model-factory/lib/rate';
import {buildCurrency} from '../../../shared/services/build-number';

function handleRequestedRateChange(index, rate) {

    const updatedRate = rate ?
        parseFloat(rate) :
        0;

    const requestId = this.queryParamRequstID;

    this.actions.updateRequestedRate(index, updatedRate, requestId);

}

function handleCommentsChange(index, event) {

    this.actions.updateComments(index, event.target.value);

}
const LaborRates = props =>
    <section className='labor-rates-claim'>
        <ul className='column-headers'>
            <li>
                <FormattedMessage id='LABOR_TYPE'/>
            </li>
            <li>
                <FormattedMessage id='REQUESTED'/>
            </li>
            <li>
                <FormattedMessage id='COMMENTS'/>
            </li>
        </ul>
        {props.rates.map((rate, index) =>
            <ul
                className='data'
                key={index}
            >
                <li>
                    {rate.description}
                </li>
                <li>
                    <EditableField
                        isEditable={!props.tcsm}
                        value={buildCurrency(rate.requestedRate)}
                    >
                        {props.queryParamRequstID ?
                            <FormattedNumberInput
                                allowNegative={false}
                                decimalPrecision={2}
                                isValidInput={value => value < 10000000}
                                onValueChange={handleRequestedRateChange.bind(props, rate.description)}
                                value={rate.requestedRate}
                            /> :
                                <FormattedNumberInput
                                    allowNegative={false}
                                    decimalPrecision={2}
                                    isValidInput={value => value < 10000000}
                                    onValueChange={handleRequestedRateChange.bind(props, rate.description)}
                                /> }
                    </EditableField>
                </li>
                <li>
                    <EditableField
                        isEditable={!props.tcsm}
                        value={rate.reasonForChange}
                    >
                        <textarea
                            className='reason-for-change'
                            maxLength='255'
                            onChange={handleCommentsChange.bind(props, rate.description)}
                            value={rate.reasonForChange}
                        />
                    </EditableField>
                </li>
            </ul>
        )}
    </section>;

LaborRates.displayName = 'LaborRates';
LaborRates.propTypes = {
    actions: PropTypes.object.isRequired,
    queryParamRequstID: PropTypes.string.isRequired,
    rates: PropTypes.arrayOf(PropTypes.instanceOf(Rate)).isRequired,
    tcsm: PropTypes.bool.isRequired
};

export default LaborRates;



// WEBPACK FOOTER //
// ./src/claim/mass-labor-rate-change/components/labor-rates.js